import { Content, ContentTitle, Text, StyledButton } from 'pages/help/styled';

export const Payment = () => {
  return (
    <>
      <Content>
        <ContentTitle>
          All the Lorem Ipsum generators on the Internet tend to repeat
          predefined chunks?
        </ContentTitle>
        <Text>
          It uses a dictionary of over 200 Latin words, combined with a handful
          of model sentence structures, to generate Lorem Ipsum which looks
          reasonable. The generated Lorem Ipsum is therefore always free from
          repetition, injected humour, or non-characteristic words etc.
          <StyledButton>Read More</StyledButton>
        </Text>
      </Content>
      <Content>
        <ContentTitle>
          All the Lorem Ipsum generators on the Internet tend to repeat
          predefined chunks?
        </ContentTitle>
        <Text>
          It uses a dictionary of over 200 Latin words, combined with a handful
          of model sentence structures, to generate Lorem Ipsum which looks
          reasonable. The generated Lorem Ipsum is therefore always free from
          repetition, injected humour, or non-characteristic words etc.
          <StyledButton>Read More</StyledButton>
        </Text>
      </Content>
      <Content>
        <ContentTitle>
          All the Lorem Ipsum generators on the Internet tend to repeat
          predefined chunks?
        </ContentTitle>
        <Text>
          It uses a dictionary of over 200 Latin words, combined with a handful
          of model sentence structures, to generate Lorem Ipsum which looks
          reasonable. The generated Lorem Ipsum is therefore always free from
          repetition, injected humour, or non-characteristic words etc.
          <StyledButton>Read More</StyledButton>
        </Text>
      </Content>
    </>
  );
};
